<template>
  <div>
    <div class="callToAction">
      <div class="container h-100">
        <div data-aos="fade-up" class="d-flex flex-column justify-content-center align-items-center align-items-lg-start h-100">
          <h2>啟動輕"食"尚流行的一日！</h2>
          <p>點選下方熱鍵訂購餐點去！</p>
          <router-link class="btn btn-primary btn-lg px-6 rounded-pill" to="/products">訂餐去</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
